import React, { FC, ReactNode, useCallback, useContext, useMemo } from 'react'
import s from './Img.module.sass'
import { CardTwoBlockContext } from '@shared/ui/Layout/CardTwoBlock/Context'
import { MediaImg } from '@shared/ui/Media/MediaImg/'
import Link from 'next/link'
import { ErrorBoundary } from '../../../../../lib/components/ErrorBoundary'

interface Props {
  children: ReactNode
  img: string
  alt: string
  classNameWrapper?: string
  classNameContent?: string
  restId?: string
  onClickInsteadLink?: (e: React.MouseEventHandler<HTMLDivElement>) => void
}

// TODO: добавить специфичности названию файла и компонента

const Img: FC<Props & React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>> = ({
  children,
  classNameWrapper = '',
  classNameContent = '',
  restId,
  img,
  alt,
  onClickInsteadLink,
  ...props
}) => {
  const [context, setContext] = useContext(CardTwoBlockContext)

  const handleClickInner = (e) => {
    onClickInsteadLink && onClickInsteadLink(e)
  }

  const Wrapper = ({ children }) =>
    onClickInsteadLink ? (
      <div
        id={'card-two-block-img'}
        className={`${s.block} ${classNameWrapper}`}
        data-size={context.size}
        onClick={handleClickInner}
        {...props}>
        {children}
      </div>
    ) : (
      // @ts-ignore
      <Link
        id={'card-two-block-img'}
        className={`${s.block} ${classNameWrapper}`}
        data-size={context.size}
        href={context.href}
        scroll={false}
        {...props}>
        {children}
      </Link>
    )

  return (
    <ErrorBoundary>
      <Wrapper>
        <div className={s['img-wrapper']}>
          <MediaImg
            image={{
              Url: img,
              Width: 594,
              Height: 396,
              Crop: null,
              Description: null,
              Copyright: null,
              Author: null,
            }}
            objectId={Number(restId)}
            height={396}
            width={594}
            borderRadius={8}
            dimmed='box-shadow'
            flexible={true}
            className={s.img}
          />
        </div>

        <div className={`${s.content} ${classNameContent}`}>{children}</div>
      </Wrapper>
    </ErrorBoundary>
  )
}

export default Img
